import api from 'services/api';

import { IParamsUpdate } from '../types';

export const getNotificatinAPI = (clientId: number, userId: number) =>
  api.get(
    `Common/NotificaAtualizacao?codigoUsuario=${userId}&codigoCliente=${clientId}`
  );

export const updateNotificatinAPI = (params: IParamsUpdate) =>
  api.put(`Common/NotificaAtualizacao`, { ...params });
